// Wording and numbers for the badge goals (Next up) and the nudges. Plain
// functions, no React.
import { fmtInt } from "../collection/badgeFormat";
import type { BadgeGoal } from "../types";

/** The most goals a Next up block shows (the server sends at most three too). */
export const MAX_GOALS = 3;

/** The goals the SPA can draw, in the server's order (closest first), at most `max`. */
export function visibleGoals(goals: readonly BadgeGoal[] | null | undefined, max = MAX_GOALS): BadgeGoal[] {
  if (!Array.isArray(goals)) return [];
  return goals.filter((g) => !!g && !!g.next && typeof g.next.code === "string").slice(0, max);
}

/** 0..100 toward the next badge: the server's pct, else worked out from the counts. */
export function goalPct(goal: Pick<BadgeGoal, "pct" | "current" | "target">): number {
  let raw = Number(goal.pct);
  if (!Number.isFinite(raw)) raw = goal.target > 0 ? (goal.current / goal.target) * 100 : 0;
  return Math.max(0, Math.min(100, Math.round(raw)));
}

/** "23 / 25" */
export function goalCount(goal: Pick<BadgeGoal, "current" | "target">): string {
  return `${fmtInt(goal.current)} / ${fmtInt(goal.target)}`;
}

/** The server's line ("2 more coffees"), or a plain count when it sent none. */
export function goalLine(goal: Pick<BadgeGoal, "line" | "remaining">): string {
  const line = typeof goal.line === "string" ? goal.line.trim() : "";
  if (line) return line;
  const left = Math.max(1, Math.round(Number(goal.remaining) || 1));
  return `${fmtInt(left)} more to go`;
}

/** What a screen reader hears for a goal: "Silver Pour. 2 more coffees. 23 of 25." */
export function goalLabel(goal: BadgeGoal): string {
  const line = goalLine(goal).replace(/[.!]+$/, "");
  return `${goal.next.name}. ${line}. ${fmtInt(goal.current)} of ${fmtInt(goal.target)}.`;
}
